// Main javascript entry point
// Should handle bootstrapping/starting application

// NOTE: afegir https://github.com/rodneyrehm/viewport-units-buggyfill

'use strict';

require('../_modules/modernizr/modernizr');
require('../_modules/promise-polyfill/promise-polyfill');
require('velocity-animate');
// require('sticky-kit/dist/sticky-kit');

// slick.js
// https://github.com/kenwheeler/slick/issues/1010#issuecomment-124861077
require('../_modules/slick-carousel-browserify-fix/slick-carousel-browserify-fix');

var objectFitImages = require('object-fit-images');
var FontfaceHandler = require('../_modules/fontface-handler/fontface-handler');
var StickyElement = require('../_modules/sticky-element/sticky-element');
var MainHeader = require('../_modules/main-header/main-header');
var MainNav = require('../_modules/main-nav/main-nav');
var Megamenu = require('../_modules/megamenu/megamenu');
var LangNav = require('../_modules/lang-nav/lang-nav');
// var BetaNav = require('../_modules/beta-nav/beta-nav');
var Search = require('../_modules/search/search');
var Carousel = require('../_modules/carousel/carousel');
var VisitMap = require('../_modules/visit-map/visit-map');
var SoftScroll = require('../_modules/soft-scroll/soft-scroll');
var Filters = require('../_modules/filters/filters');
var Pswp = require('../_modules/pswp/pswp');
var Modal = require('../_modules/modal/modal');
var SearchProfiles = require('../_modules/search-profiles/search-profiles');
var ArtworkHero = require('../_modules/artwork-hero/artwork-hero');
var Collapse = require('../_modules/collapse/collapse');
var Chronology = require('../_modules/chronology/chronology');
var Scrollspy = require('../_modules/scrollspy/scrollspy');
var FormValidation = require('../_modules/form-validation/form-validation');
var ArtworkCarousel = require('../_modules/artwork-carousel/artwork-carousel');
var Comments = require('../_modules/comments/comments');
var Popover = require('../_modules/popover/popover');
var CookieAlert = require('../_modules/cookie-alert/cookie-alert');
var Linked = require('../_modules/linked/linked');
var EntryHeader = require('../_modules/entry-header/entry-header');
var ResponsiveEmbed = require('../_modules/responsive-embed/responsive-embed');
var MultimediaHero = require('../_modules/multimedia-hero/multimedia-hero');
var MainFooter = require('../_modules/main-footer/main-footer');

new FontfaceHandler().init();

window.addEventListener('load', function() {
  document.documentElement.className += ' window-loaded';
});

$(function() {
  new StickyElement().init();
  new MainHeader().init();
  new MainNav().init();
  new Megamenu().init();
  new LangNav().init();
  // new BetaNav().init();
  new Search().init();
  new Carousel().init();
  new VisitMap().init();
  new SoftScroll().init();
  new Filters().init();
  new Pswp().init();
  new Modal().init();
  new SearchProfiles().init();
  new ArtworkHero().init();
  new Collapse().init();
  new Chronology().init();
  new Scrollspy().init();
  new FormValidation().init();
  new ArtworkCarousel().init();
  new Comments().init();
  new Popover().init();
  new CookieAlert().init();
  new Linked().init();
  new EntryHeader().init();
  new ResponsiveEmbed().init();
  new MultimediaHero().init();
  new MainFooter().init();
  objectFitImages();
});
